import React, { createContext, useContext, useState } from "react";
  export interface  user  {
    status : number ;
    email : string;
    fname : string;
    lname : string;
    phone : string;
    ip :  string;
  }
  interface Stage {
    stage_uid: string;
    stage_name: string;
    stage_status: string | "";
    stage_priority: string;
    documents?: {
      post_id: string;
      post_name: string;
      document_status: string;
    }[];
  }
  interface AccessDOCOBJ {
    [key: string]: string | Stage[]; // dynamic string keys OR all_stage_info
    all_stage_info: Stage[];
  }
interface ContextType {
  userLoginData: user;
  setUserLoginData:  React.Dispatch<React.SetStateAction<user>>;
  faqScroll:boolean;
  setFaqScroll : (data:boolean) => void;
  loadingLoader: boolean;
  setLoadingLoader: (data: boolean) => void;
  accessDoc: AccessDOCOBJ;
  setAccessDoc :(data : AccessDOCOBJ) =>void
}

const defaultState = {
  userLoginData: {
    status : 0 ,
    email :"" ,
    fname : "" ,
    lname :"" ,
    phone :"" ,
    ip :""
 
  },
  setUserLoginData: () => {},
  loadingLoader: false,
  setFaqScroll: ()=>{},
  faqScroll:false,
  setLoadingLoader: () => {},
 accessDoc: {
    "13678": "de",
    "9431": "de",
    "13656": "de",
    "10899": "de",
    "10911": "de",
    "10893": "de",
    "11482": "de",
    "11420": "de",
    "7033":"de",
    "10509":'de',
    "11458":"de",
    "12146":"de",
    "12879":"de",
    "13029":"de",
    "12754":"de",
    "7343":"de",
    all_stage_info: []
  },
  
  setAccessDoc :() => {}

} as ContextType;
export const Context = createContext(defaultState);

// Define a custom hook to use the context
const useToggle = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error("useToggle must be used within a ToggleProvider");
  }
  return context;
};

// Create a provider component to wrap around your app
const ContextProvider = ({ children }: any) => {
  const [userLoginData, setUserLoginData] = useState({
    status : 0 ,
    email :"" ,
    fname : "" ,
    lname :"" ,
    phone :"" ,
    ip:"",
 
  });
 const [faqScroll, setFaqScroll] = useState(false)
  const [loadingLoader, setLoadingLoader] = useState(false);
 
  const [accessDoc, setAccessDoc] = useState<AccessDOCOBJ>({
    "13678": "de",
    "9431": "de",
    "13656": "de",
    "10899": "de",
    "10911": "de",
    "10893": "de",
    "11482": "de",
    "11420": "de",
    "7033":"de",
    "10509":'de',
    "11458":"de",
    "12146":"de",
    "12879":"de",
    "13029":"de",
    "12754":"de",
    "7343":"de",
    all_stage_info: []
  });
  
  const contextValue: ContextType = {
    userLoginData,
    setUserLoginData,
    loadingLoader,
    setLoadingLoader,
    accessDoc,
    setAccessDoc,
    setFaqScroll,
    faqScroll
  };

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};

export { ContextProvider, useToggle };
